// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__iPIBo","dot":"nav_dot__yOyyo","active":"nav_active__27h79"};